import React from 'react';
import { ShoppingBagIcon } from 'lucide-react';
import MerchCategoryPage, { MerchProduct } from '../../components/Merch/MerchCategoryPage';
const accessoryProducts: MerchProduct[] = [{
  id: 'a1',
  name: 'Canvas Book Tote',
  vendorName: 'PageTurnerTotes',
  vendorSlug: 'page-turner-totes',
  vendorImage: 'https://images.unsplash.com/photo-1535585209827-a15fcdbc4c2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1544816155-12df9643f363?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 18.0,
  rating: 4.8,
  reviewCount: 215,
  subcategory: 'Tote Bags',
  tags: ['canvas', 'eco-friendly', 'durable'],
  description: 'Heavy-duty canvas tote capable of carrying 10+ hardcovers. Features an inner pocket.',
  shipping: 'Worldwide',
  location: 'Austin, TX'
}, {
  id: 'a2',
  name: 'Sword Enamel Pin',
  vendorName: 'FantasyRealmCrate',
  vendorSlug: 'fantasy-realm-crate',
  vendorImage: 'https://images.unsplash.com/photo-1578950435899-d1c1bf932b1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1615212356286-466d33302783?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 12.0,
  rating: 4.9,
  reviewCount: 180,
  subcategory: 'Enamel Pins',
  tags: ['fantasy', 'collectible', 'gold'],
  description: 'Gold-plated enamel pin featuring a legendary sword entwined with vines.',
  shipping: 'Worldwide',
  location: 'Denver, CO'
}, {
  id: 'a3',
  name: 'Wooden Bookmark Set',
  vendorName: 'WhimsyReads',
  vendorSlug: 'whimsy-reads',
  vendorImage: 'https://images.unsplash.com/photo-1586892477838-2b96e85e0f96?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 15.0,
  rating: 4.7,
  reviewCount: 95,
  subcategory: 'Bookmarks',
  tags: ['wood', 'handmade', 'nature'],
  description: 'Set of 3 engraved wooden bookmarks with forest motifs.',
  shipping: 'Worldwide',
  location: 'Portland, OR'
}, {
  id: 'a4',
  name: 'Book Locket Necklace',
  vendorName: 'BookishTreasuresSydney',
  vendorSlug: 'bookish-treasures-sydney',
  vendorImage: 'https://images.unsplash.com/photo-1526280760714-f9e8b26f318f?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 35.0,
  rating: 4.6,
  reviewCount: 56,
  subcategory: 'Jewelry',
  tags: ['vintage', 'gold', 'locket'],
  description: 'Vintage-style locket that opens to reveal tiny paper pages.',
  shipping: 'Worldwide',
  location: 'Sydney, Australia'
}, {
  id: 'a5',
  name: 'Reader Phone Case',
  vendorName: 'LiteraryThreads',
  vendorSlug: 'literary-threads',
  vendorImage: 'https://images.unsplash.com/photo-1556821840-3a63f95609a7?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1586105251261-72a756497a11?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 25.0,
  rating: 4.5,
  reviewCount: 88,
  subcategory: 'Phone Cases',
  tags: ['tech', 'protective', 'pattern'],
  description: 'Durable phone case with a colorful bookshelf pattern.',
  shipping: 'Worldwide',
  location: 'Seattle, WA'
}, {
  id: 'a6',
  name: 'Vinyl Sticker Pack',
  vendorName: 'BangkokBookDesigns',
  vendorSlug: 'bangkok-book-designs',
  vendorImage: 'https://images.unsplash.com/photo-1528698827591-e19ccd7bc23d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1572375992501-4b0892d50c69?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 8.0,
  rating: 4.9,
  reviewCount: 310,
  subcategory: 'Stickers',
  tags: ['waterproof', 'laptop', 'cute'],
  description: 'Pack of 10 waterproof vinyl stickers featuring cute book characters.',
  shipping: 'Worldwide',
  location: 'Bangkok, Thailand'
}, {
  id: 'a7',
  name: 'Embroidered Book Sleeve',
  vendorName: 'KiwiBookCrafts',
  vendorSlug: 'kiwi-book-crafts',
  vendorImage: 'https://images.unsplash.com/photo-1516876437184-593fda40c542?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1621351183012-e2f9972dd9bf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 28.0,
  rating: 4.8,
  reviewCount: 74,
  subcategory: 'Book Sleeves',
  tags: ['protective', 'handmade', 'padded'],
  description: 'Padded fabric sleeve to protect your paperbacks in your bag.',
  shipping: 'Worldwide',
  location: 'Wellington, NZ'
}, {
  id: 'a8',
  name: 'Quill Pen Set',
  vendorName: 'QuillAndInkArt',
  vendorSlug: 'quill-and-ink-art',
  vendorImage: 'https://images.unsplash.com/photo-1603827457577-609e6f42a45e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1513519245088-0e12902e5a38?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 45.0,
  rating: 4.7,
  reviewCount: 45,
  subcategory: 'Stationery',
  tags: ['writing', 'calligraphy', 'vintage'],
  description: 'Authentic feather quill pen with nibs and ink pot.',
  shipping: 'Worldwide',
  location: 'Boston, MA'
}];
const Accessories = () => {
  return <MerchCategoryPage title="Bookish Accessories" description="The perfect companions for your reading life. Find bookmarks, totes, pins, and more to show off your literary style." icon={<ShoppingBagIcon className="h-5 w-5" data-id="element-10472" data-mp="30h43cegfok7g" />} products={accessoryProducts} filterOptions={{
    subcategories: ['Tote Bags', 'Bookmarks', 'Enamel Pins', 'Jewelry', 'Phone Cases', 'Stickers', 'Book Sleeves', 'Stationery'],
    priceRanges: [{
      label: 'Under $15',
      min: 0,
      max: 15
    }, {
      label: '$15 - $30',
      min: 15,
      max: 30
    }, {
      label: '$30+',
      min: 30,
      max: null
    }],
    vendors: Array.from(new Set(accessoryProducts.map(p => p.vendorName))).sort()
  }} data-id="element-10471" data-mp="3agcukzjwzkq4" />;
};
export default Accessories;